import styled from 'styled-components';

export const Header = styled.div`
  min-width: 0;
  width: 100%;
  padding: 20px 25px;
  background: var(--color-surface);
  box-shadow: 0 1px 6px var(--color-shadow);
  border-bottom: 1px solid var(--color-border);
  position: relative;

  .right-side {
    position: absolute;
    right: 25px;
    top: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }
  @media (max-width: 767px) {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 16px;
    .right-side {
      position: static;
      flex-wrap: wrap;
    }
  }
`;
